/**
 * configFormHelpers.js — small resolution helpers shared by `ConfigForm` (edit mode) and
 * `ConfigFormView` (view mode), so both renderers interpret `field.variants` and dynamic
 * `field.options` identically.
 */

export const resolveFieldForVariant = (field, variant) => {
  const override = variant && field.variants ? field.variants[variant] : undefined;
  return override ? { ...field, ...override } : field;
};

export const resolveFieldOptions = (field, form, extra) => {
  const resolved = typeof field.options === "function" ? field.options(form || {}, extra || {}) : field.options;
  return Array.isArray(resolved) ? resolved : [];
};

export const resolveFieldDisabled = (field, { disabled, hasPermission } = {}) => {
  if (disabled || field.disabled) return true;
  if (field.permission && typeof hasPermission === "function" && !hasPermission(field.permission)) return true;
  return false;
};
